import { useMemo } from 'react'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../constants/common'
import { hasFormikFormEmptyRequired } from '../../../Formik'
import { useFormFilesValidationErrorsNotification } from '../useFormFilesValidationErrorsNotification'
import { useFormNoChangesNotification } from '../useFormNoChangesNotification'
import { useFormRequiredNotification } from '../useFormRequiredNotification'
import { useFormResponsibleManagersLimitErrorNotification } from '../useFormResponsibleManagersLimitErrorNotification'
import { useFormServerNonFieldNotification } from '../useFormServerNonFieldNotification'

export function useFormValidationErrorsNotification({
  checkFormikFormEmptyRequired = hasFormikFormEmptyRequired,
  files,
  formikContext,
  requiredNotificationProps,
  responsibleManagersFieldName,
  onRemoveNotification,
  onSetNotification,
}) {
  const useHandlerFormikContext = !formikContext ? useFormikContext : undefined

  const { errors = EMPTY_LIST, submitCount } =
    useHandlerFormikContext?.() || formikContext

  const hasEmptyRequired = useMemo(
    () => checkFormikFormEmptyRequired(errors),
    [checkFormikFormEmptyRequired, errors]
  )

  const useHandlerFormFilesValidationErrorsNotification =
    files && useFormFilesValidationErrorsNotification

  useFormRequiredNotification({
    ...requiredNotificationProps,
    hasEmptyRequired,
    removeNotification: onRemoveNotification,
    setNotification: onSetNotification,
    submitCount,
  })

  useFormNoChangesNotification({
    errors,
    onRemoveNotification,
    onSetNotification,
  })

  useFormResponsibleManagersLimitErrorNotification({
    errors,
    responsibleManagersFieldName,
    onRemoveNotification,
    onSetNotification,
  })

  useFormServerNonFieldNotification({
    errors,
    removeNotification: onRemoveNotification,
    setNotification: onSetNotification,
  })

  useHandlerFormFilesValidationErrorsNotification?.({
    files,
    formikContext,
    onRemoveNotification,
    onSetNotification,
  })
}
